<template>

  <div data-testid="financial-close-cycle-side-nav" class="fc-cycle-side-nav"
    :class="{ 'fc-cycle-side-nav--mini': mini }">

    <div>

      <div data-testid="financial-close-cycle-side-nav__header" class="fc-side-nav__header">

        <span v-if="!mini" class="fc-side-nav__header-title">Cycle Menu</span>

        <button data-testid="financial-close-cycle-side-nav__toggle" type="button" class="fc-side-nav__toggle"
          :aria-label="mini ? 'Expand navigation' : 'Collapse navigation'" @click="$emit('toggle-mini')">

          <img :src="FC_NAV_ICONS.COLLAPSE_NAV" alt="" class="fc-side-nav__toggle-icon"
            :class="{ 'fc-side-nav__toggle-icon--expand': mini }" />

        </button>

      </div>



      <div data-testid="financial-close-cycle-side-nav__items" class="fc-side-nav__items">

        <template v-for="(item, index) in primaryItems">

          <noa-agent-nav-group v-if="item.items && item.items.length" :key="`group-${item.name}-${index}`" :mini="mini"
            :label="item.name" :icon="item.icon" :items="item.items" :selected-item="selectedItem"
            @navigate="onNavigate" />

          <router-link v-else :key="`item-${item.name}-${index}`"
            :data-testid="`financial-close-cycle-side-nav__item--${index}`" class="fc-side-nav__item" :class="{

              'fc-side-nav__item--mini': mini,

              'fc-side-nav__item--active': isActive(item)

            }" :to="linkFor(item)" @click.native="onNavigate(item)">

            <v-tooltip v-if="mini" right content-class="tooltip-right">

              <template #activator="{ on, attrs }">

                <img v-if="item.icon" v-bind="attrs" v-on="on" :src="item.icon" alt="" class="fc-side-nav__icon" />

              </template>

              <span>{{ item.name }}</span>

            </v-tooltip>

            <template v-else>

              <img v-if="item.icon" :src="item.icon" alt="" class="fc-side-nav__icon" />

              <span class="fc-side-nav__label">{{ item.name }}</span>

            </template>

          </router-link>

        </template>

      </div>

    </div>



    <div v-if="cycleSettingsHref" data-testid="financial-close-cycle-side-nav__footer" class="fc-side-nav__footer">

      <router-link data-testid="financial-close-cycle-side-nav__cycle-settings" class="fc-side-nav__item" :class="{

        'fc-side-nav__item--mini': mini,

        'fc-side-nav__item--active': isCycleSettingsActive

      }" :to="linkFor({ href: cycleSettingsHref })" @click.native="emitSelected(FC_MENU_NAMES.CYCLE_SETTINGS)">

        <v-tooltip v-if="mini" right content-class="tooltip-right">

          <template #activator="{ on, attrs }">

            <img v-bind="attrs" v-on="on" :src="FC_NAV_ICONS.CYCLE_SETTING" alt="" class="fc-side-nav__icon" />

          </template>

          <span>{{ FC_MENU_NAMES.CYCLE_SETTINGS }}</span>

        </v-tooltip>

        <template v-else>

          <img :src="FC_NAV_ICONS.CYCLE_SETTING" alt="" class="fc-side-nav__icon" />

          <span class="fc-side-nav__label">{{ FC_MENU_NAMES.CYCLE_SETTINGS }}</span>

        </template>

      </router-link>

    </div>

  </div>

</template>



<script>

import NoaAgentNavGroup from './NoaAgentNavGroup.vue';

import appConstants from '@/plugins/constants';

import {

  FC_MENU_NAMES,

  FC_MENU_LEGACY_NAMES,

  FC_NAV_ICONS,

  FC_ROUTES,

  getCycleNavDisplayName

} from '@/modules/financialclose/utils/constants';



export default {

  name: 'FinancialCloseCycleSideNav',

  components: { NoaAgentNavGroup },

  props: {

    mini: { type: Boolean, default: true },

    selectedItem: { type: String, default: null },

    cycleId: { type: String, default: null }

  },

  emits: ['update:selectedItem', 'toggle-mini'],

  data() {

    return {

      FC_MENU_NAMES,

      FC_NAV_ICONS

    };

  },

  computed: {

    botName() {

      return appConstants.BOT_NAME;

    },

    cycleItems() {

      const list = this.$store.state.m_financialclose?.CycleList || [];

      const cycle = list.find((c) => c._id === this.cycleId);

      return cycle?.items || [];

    },

    primaryItems() {

      const accrualsbotEnabled = this.$store.state.accrualsbotEnabled === true;

      return (this.cycleItems || [])

        .filter((item) => item.name !== FC_MENU_NAMES.CYCLE_SETTINGS)

        .filter((item) => item.name !== FC_MENU_NAMES.ACCRUALS || accrualsbotEnabled)

        .map((item) => {

          let name = item.name;

          if (name === this.botName || name === FC_MENU_LEGACY_NAMES.ARC_AGENT) {

            name = appConstants.BOT_NAME;

          } else {

            name = getCycleNavDisplayName(name);

          }

          return { ...item, name };

        });

    },

    cycleSettingsHref() {

      if (!this.cycleId) return null;

      return FC_ROUTES.CYCLE_SETTINGS_TEAM(this.cycleId);

    },

    isCycleSettingsActive() {

      const path = this.$route.path || '';

      return (

        path.includes(`/project/cycle-settings/${this.cycleId}`) ||

        path.includes(FC_ROUTES.USERS(this.cycleId)) ||

        path.includes(FC_ROUTES.THRESHOLD(this.cycleId))

      );

    }

  },

  watch: {

    '$route.path': {

      immediate: true,

      handler() {

        const match = (this.primaryItems || []).find((item) => this.isActive(item));

        const next = match?.name || (this.isCycleSettingsActive ? FC_MENU_NAMES.CYCLE_SETTINGS : null);

        if (next !== this.selectedItem) {

          this.$emit('update:selectedItem', next);

        }

      }

    }

  },

  methods: {

    linkFor(item) {

      if (!item?.href) return {};

      return this.$nova.gotoLink({ path: item.href }, true);

    },

    isActive(item) {

      if (!item) return false;

      const href = (item.href || '').replace(/\/$/, '');

      const path = (this.$route.path || '').replace(/\/$/, '');

      return !!(href && (path === href || path.startsWith(`${href}/`)));

    },

    emitSelected(name) {

      this.$root.closeFloatingComponents?.(name);

      this.$emit('update:selectedItem', name);

    },

    onNavigate(item) {

      if (item?.name) this.emitSelected(item.name);

    }

  }

};

</script>



<style lang="scss" scoped>
@import './FinancialCloseSideNav.scss';
</style>
